import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/** LIBRARIES */
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';

/** COMPONENTS */
import { NavbarComponent } from './components/navbar.component';
@NgModule({
  declarations: [NavbarComponent],
  imports: [CommonModule, MatMenuModule, MatButtonModule, MatIconModule, MatToolbarModule, MatSidenavModule],
  exports: [NavbarComponent],
})
export class NavbarModule {}
